import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  FormInput,
  FormSelect,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  CardHeader,
  CardBody,
  ButtonGroup,
  Button
} from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import {requestProfilPlatformPractitioner} from "../../actions/practitioners.action";
import {connect} from "react-redux";
import dateFormat from "dateformat";
import CopyText from "../../components/form/CopyText";
import {NavLink} from "react-router-dom";

class Platform extends React.Component {
  constructor(props) {
    super(props);
    let uuid = this.props.match.params.id;
    this.props.loadData(uuid);
  }

  render() {
    return (
      <Container fluid className="main-content-container px-4">
        {this.props.practitioners.fetching || (this.props.practitioners.data && this.props.practitioners.data.length > 0) ? (
          <div className="flex-center">
            <div className="text-center d-block">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <Row noGutters className="page-header pt-4 fixed">
              <PageTitle
                title={this.props.practitioners.data.first_name + ' ' + this.props.practitioners.data.last_name}
                subtitle="Profil" className="text-sm-left mb-3"/>
            </Row>
            <Row>
              {/* Page Header :: Actions */}
              <Col xs="12" sm="4" className="col d-flex align-items-center offset-sm-4">
                <ButtonGroup size="sm" className="d-inline-flex mb-3 mb-sm-0 mx-auto">
                  <Button theme="white" tag={NavLink}
                          to={'/praticiens/' + this.props.practitioners.data.id + '/profil/connect'}>
                    Connect
                  </Button>
                  <Button theme="white" tag={NavLink}
                          to={'/praticiens/' + this.props.practitioners.data.id + '/profil/platform'}>
                    Platform
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="12" className="mx-auto mt-4">
                <Row>
                  <Col lg="4" className="mx-auto">
                    <Card small className="edit-user-details">
                      <CardHeader className="border-bottom">
                        <Row>
                          <Col md="6">
                            <h6 className="m-0">Détails</h6>
                          </Col>
                          <Col md="6" className="text-right">
                            {this.props.practitioners.data.available && this.getStatusUser(this.props.practitioners.data.available)}
                          </Col>
                        </Row>
                      </CardHeader>
                      <CardBody>
                        <Row className="m-0">
                          <Col md="3" className="form-group">
                            <label>Civilité</label>
                            <FormSelect
                              className={this.props.practitioners.data.title === null ? 'missing text-uppercase' : 'text-uppercase'}
                              disabled>
                              <option defaultValue>{this.props.practitioners.data.title}</option>
                            </FormSelect>
                          </Col>
                          <Col md="5" className="form-group">
                            <label htmlFor="lastName">Nom</label>
                            <FormInput
                              type="text"
                              defaultValue={this.props.practitioners.data.last_name}
                              disabled
                            />
                          </Col>
                          <Col md="4" className="form-group">
                            <label>Prénom</label>
                            <FormInput
                              defaultValue={this.props.practitioners.data.first_name}
                              disabled
                            />
                          </Col>
                          <Col md="6" className="form-group">
                            <label htmlFor="lastName">Date de naissance</label>
                            <InputGroup
                              className={this.props.practitioners.data.birth_date === null && 'missing'}
                              seamless>
                              <InputGroupAddon type="prepend">
                                <InputGroupText>
                                  <i className="material-icons practitioner-color">calendar_today</i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <FormInput

                                defaultValue={this.props.practitioners.data.accounts && this.props.practitioners.data.accounts[0].owner.birth_date && dateFormat(new Date(this.props.practitioners.data.accounts[0].owner.birth_date), "dd-mm-yyyy")}
                                disabled
                              />
                            </InputGroup>
                          </Col>
                          <Col md="12" className="form-group">
                            <label htmlFor="phoneNumber">Adresse</label>
                            <InputGroup seamless>
                              <InputGroupAddon type="prepend">
                                <InputGroupText>
                                  <i className="material-icons practitioner-color">home</i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <FormInput
                                defaultValue={this.props.practitioners.data.address}
                                disabled
                              />
                            </InputGroup>
                          </Col>
                          <Col md="12" className="form-group">
                            <label htmlFor="phoneNumber">Téléphone</label>
                            <InputGroup seamless>
                              <InputGroupAddon type="prepend">
                                <InputGroupText>
                                  <i className="material-icons practitioner-color">&#xE0CD;</i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <FormInput
                                defaultValue={this.props.practitioners.data.phone_number}
                                disabled
                              />
                            </InputGroup>
                          </Col>
                          <Col md="12" className="form-group">
                            <label htmlFor="emailAddress">Email</label>
                            <InputGroup seamless>
                              <InputGroupAddon type="prepend">
                                <InputGroupText>
                                  <i className="material-icons practitioner-color">&#xE0BE;</i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <FormInput
                                defaultValue={this.props.practitioners.data.accounts && this.props.practitioners.data.accounts[0].owner && this.props.practitioners.data.accounts[0].owner.email}
                                disabled
                              />
                            </InputGroup>
                          </Col>
                          <Col md="12" className="form-group">
                            <label htmlFor="lastName">Uuid</label>
                            <CopyText
                              text={this.props.practitioners.data.id}
                            />
                          </Col>
                          <Col md="12" className="form-group">
                            <label htmlFor="lastName">Timezone</label>
                            <CopyText
                              text={this.props.practitioners.data.timezone}
                            />
                          </Col>
                          <Col md="6" className="form-group">
                            <label htmlFor="lastName">Date d'inscription</label>
                            <InputGroup seamless>
                              <InputGroupAddon type="prepend">
                                <InputGroupText>
                                  <i className="material-icons practitioner-color">calendar_today</i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <FormInput
                                defaultValue={this.props.practitioners.data.created_at && dateFormat(new Date(this.props.practitioners.data.created_at), "dd-mm-yyyy")}
                                disabled
                              />
                            </InputGroup>
                          </Col>
                          <Col md="6" className="form-group">
                            <label htmlFor="lastName">Dernière mise à jour</label>
                            <InputGroup seamless>
                              <InputGroupAddon type="prepend">
                                <InputGroupText>
                                  <i className="material-icons practitioner-color">calendar_today</i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <FormInput
                                defaultValue={this.props.practitioners.data.updated_at && dateFormat(new Date(this.props.practitioners.data.updated_at), "dd-mm-yyyy")}
                                disabled
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg="8" className="mx-auto">
                    <Row>
                      <Col lg="12">
                        <Card small className="edit-user-details mb-4">
                          <CardHeader className="border-bottom">
                            <h6 className="m-0">Renseignements médicaux</h6>
                          </CardHeader>
                          <CardBody>
                            <Row className="m-0">
                              <Col md="4" className="form-group">
                                <label>RPPS</label>
                                <FormInput
                                  defaultValue={this.props.practitioners.data.rpps}
                                  className={(this.props.practitioners.data.adeli === null && this.props.practitioners.data.rpps === null) && 'missing'}
                                  disabled
                                />
                              </Col>
                              <Col md="4" className="form-group">
                                <label htmlFor="lastName">ADELI</label>
                                <FormInput
                                  type="text"
                                  className={(this.props.practitioners.data.adeli === null && this.props.practitioners.data.rpps === null) && 'missing'}
                                  defaultValue={this.props.practitioners.data.adeli}
                                  disabled
                                />
                              </Col>
                            </Row>
                          </CardBody><CardHeader className="border-bottom">
                            <h6 className="m-0">Renseignements de facturation</h6>
                          </CardHeader>
                          <CardBody>
                            <Row className="m-0">
                              <Col md="4" className="form-group">
                                <label>RPPS</label>
                                <FormInput
                                  defaultValue={this.props.practitioners.data.accounts && this.props.practitioners.data.accounts[0].iban}
                                  disabled
                                />
                              </Col>
                              <Col md="4" className="form-group">
                                <label>Compte Stripe</label>
                                <FormInput
                                  defaultValue={this.props.practitioners.data.accounts && this.props.practitioners.data.accounts[0].psp_account}
                                  disabled
                                />
                              </Col>
                              <Col md="4" className="form-group">
                                <label>Status du compte Stripe</label>
                                <FormInput
                                  defaultValue={this.props.practitioners.data.accounts && this.props.practitioners.data.accounts[0].status}
                                  disabled
                                />
                              </Col>
                            </Row>
                          </CardBody>
                          <CardHeader className="card-header-border">
                            <h6 className="m-0">Liste des actes</h6>
                          </CardHeader>
                          <CardBody>
                            {this.props.practitioners.data.accounts && this.props.practitioners.data.accounts[0].products && this.props.practitioners.data.accounts[0].products.map(function (value, key) {
                              return (
                                <Row className="m-0" key={key}>
                                  <Col md="4" className="form-group">
                                    <label htmlFor="lastName">Nom</label>
                                    <FormInput
                                      type="text"
                                      defaultValue={value.name}
                                      disabled
                                    />
                                  </Col>
                                  <Col md="2" className="form-group">
                                    <label htmlFor="lastName">Tarif</label>
                                    <FormInput
                                      type="text"
                                      defaultValue={value.unit_price}
                                      disabled
                                    />
                                  </Col>
                                  <Col md="2" className="form-group">
                                    <label htmlFor="lastName">Durée</label>
                                    <FormInput
                                      type="text"
                                      defaultValue={value.duration}
                                      disabled
                                    />
                                  </Col>
                                  <Col md="4" className="form-group">
                                    <label htmlFor="lastName">Canal de téléconsultation</label>
                                    <FormInput
                                      type="text"
                                      defaultValue={value.channel}
                                      disabled
                                    />
                                  </Col>
                                </Row>
                              );
                            })}
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        )}
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    practitioners: state['practitioners'],
  };
}

const mapDispatchToProps = dispatch => ({
  loadData: (e) => dispatch(requestProfilPlatformPractitioner(e)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Platform);



// WEBPACK FOOTER //
// ./src/views/Practitioners/Platform.js